<span><slot /></span>

<style>
	span {
		text-shadow: 0 0 0.2em #f8f8;
	}
</style>
